import React from 'react';
import { Div, Skeleton, Text } from '@pezeshk-book/ui-kit';
import Image from '@elements/image';
import ComplaintItem from './sub-components/complaint-item';
import { useSelector } from 'react-redux';
import { RootState } from '@store/root-reducer';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';
import { LocaleTypes } from '@dictionaries-types';

const ComplaintsList = () => {
  const { complaintsList, dataLoading } = useSelector((state: RootState) => state.clientComplaints);
  const { lang } = useParams<{ lang : LocaleTypes }>();
  const { dashboard: { complaints } } = getDictionary(lang);

  if (dataLoading) {
    return (
      <Div className={'flex-col gap-4 w-full'}>
        <Skeleton shape={'rectangular'} size={'large'} className={'w-full rounded !h-[182px]'} color={'control'}/>
        <Skeleton shape={'rectangular'} size={'large'} className={'w-full rounded !h-[182px]'} color={'control'}/>
        <Skeleton shape={'rectangular'} size={'large'} className={'w-full rounded !h-[182px]'} color={'control'}/>
        <Skeleton shape={'rectangular'} size={'large'} className={'w-full rounded !h-[182px]'} color={'control'}/>
        <Skeleton shape={'rectangular'} size={'large'} className={'w-full rounded !h-[182px]'} color={'control'}/>
      </Div>
    );
  }
  if (complaintsList && complaintsList.length > 0) {
    return (
      <Div className={'flex-col w-full gap-4'}>
        {complaintsList.map((item: any, index: any) => (
          <ComplaintItem key={`order_${index}`} complaintItem={item}/>
        ))}
      </Div>
    );
  }

  return (
    <Div className={'items-center flex-col w-full'}>
      <Div className={'w-48 h-36 sm:w-[392px] sm:h-[310px] md:w-[620px] md:h-[400px] relative object-contain'}>
        <Image
          src={'/images/contact-information/calendar-clouds.svg'}
          className={'object-contain'}
          alt={'map'}
          fill={true}
        />
      </Div>
      <Text
        color={'grey.600'}
        type={'bold'}
        typography={'xl'}
        className={'mt-16 mb-5'}>
        {complaints.no_info.title}
      </Text>
    </Div>
  );
};

export default ComplaintsList;
